module.exports = __webpack_public_path__ + "static/media/(V)-Cia-Termal-Beachewear-Moda-Feminina.c2d43297.jpg";